import { render } from "./LoginSettingsModal.vue?vue&type=template&id=60299786"
import script from "./LoginSettingsModal.vue?vue&type=script&lang=js"
export * from "./LoginSettingsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__